import { Tooltip } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import UniqueId from '../../../../../services/uid/UniqueId';
import { AfterPrefix, MessageKey } from '../../../../../types';
import CommandsToolbarContainer from '../../../commands/CommandsToolbarContainer';

import FieldsConditionsButton from './FieldsConditionsButton';

interface TitleProps {
  className?: string;
  title?: string;
  rowsCount: number;
  fullCount: number;
  isCommandsCreated: boolean;
  selected: number;
  datasetId: UniqueId;
}

const useStyles = createUseStyles({
  info: {
    composes: ['row', 'no-wrap', 'items-center'],
    flex: '0 1 auto',
    minWidth: 0,
  },
  toolbar: {
    flex: '1 3 200px',
    minWidth: 0,
    width: '100%',
  },
  tooltip: {
    whiteSpace: 'nowrap',
    textAlign: 'right',
  },
  counter: {
    display: 'inline-block',
    userSelect: 'none',
    cursor: ({ fullCount, selected, rowsCount }: TitleProps) =>
      fullCount > 0 && (rowsCount !== fullCount || selected) ? 'help' : 'auto',
  },
  filterIcon: {
    paddingRight: 10,
  },
});

type CounterKey = AfterPrefix<MessageKey, 'core.category.grid.counter.'>;

const getMessage = (name: CounterKey) => ({
  id: `core.category.grid.counter.${name}` as `core.category.grid.counter.${CounterKey}`,
  defaultMessage: `${name.toUpperCase()}: {counter}`,
});

const Title: React.FC<TitleProps> = props => {
  const {
    className,
    fullCount,
    isCommandsCreated,
    title,
    rowsCount,
    selected,
    datasetId,
  } = props;
  const { formatMessage } = useIntl();
  const classes = useStyles(props);

  return (
    <div className={className}>
      <div className={classes.info}>
        <Tooltip label={title}>
          <div className="m-pr-sm text-ellipsis">{title}</div>
        </Tooltip>
        {fullCount > 0 && (
          <Tooltip
            label={
              <div className={classes.tooltip}>
                {rowsCount !== fullCount &&
                  formatMessage(getMessage('found'), {
                    counter: rowsCount,
                  })}
                {rowsCount !== fullCount && '; '}
                {formatMessage(getMessage('total'), {
                  counter: fullCount,
                })}
                {selected > 0 && '; '}
                {selected > 0 &&
                  formatMessage(getMessage('selected'), {
                    counter: selected,
                  })}
              </div>
            }
          >
            <div className={classes.counter}>
              ({rowsCount !== fullCount && `${rowsCount} / `}
              {fullCount}
              {selected > 0 && ` : ${selected}`})
            </div>
          </Tooltip>
        )}
        <FieldsConditionsButton datasetId={datasetId} />
      </div>
      {isCommandsCreated && (
        <CommandsToolbarContainer
          className={classes.toolbar}
          datasetId={datasetId}
        />
      )}
    </div>
  );
};

export default Title;
